<template>
	<v-container grid-list-md class="container--box">
		<app-head :title="$t('title.make_a_reservation')" />
		<v-card>
			<v-card-title primary-title>
				{{ $t("title.make_a_reservation") }}
			</v-card-title>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<ReservationStepper :step="1"></ReservationStepper>
					</v-flex>
					<v-flex xs12>
						<ReservationTenantGrid
							:tenants="tenants"
						></ReservationTenantGrid>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import ReservationStepper from "@Reservation/components/ReservationStepper.vue";
import ReservationTenantGrid from "@Reservation/components/ReservationTenantGrid.vue";
export default {
	components: {
		ReservationStepper,
		ReservationTenantGrid,
	},
	props: ["tenants"],
};
</script>